import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import LandingPage from "./LandingPage";
import { useAuth } from "../context/AuthContext";

export default function HomeRedirect() {
  const { user, loading } = useAuth();

  if (loading) return null;

  if (user) {
    // Adjust path to match your dashboard structure!
    return <Navigate to="/homepage/dashboard" replace />;
  }

  return <LandingPage />;
}
